import store from "../store";
import Constants from "../config/constants";
import {
  serviceCreateDiet,
  serviceGetDiet,
  serviceUpdateDiet,
  serviceDeleteDiet,
} from "../services/Diet.service";

export const FETCH_INIT = "FETCH_INIT_DIET";
export const FETCHED = "FETCHED_DIET";
export const FETCHED_FAIL = "FETCHED_FAIL_DIET";
export const FETCHED_FILTER = "FETCHED_FILTER_DIET";
export const FETCH_NEXT = "FETCH_NEXT_DIET";
export const FILTER = "FILTER_DIET";
export const RESET_FILTER = "RESET_FILTER_DIET";
export const SET_SORTING = "SET_SORTING_DIET";
export const SET_FILTER = "SET_FILTER_DIET";
export const SET_PAGE = "SET_PAGE_DIET";
export const CHANGE_PAGE = "CHANGE_PAGE_DIET";
export const CHANGE_STATUS = "CHANGE_STATE_DIET";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_DIET";
export const CREATE_DATA = "CREATE_DIET";
export const UPDATE_DATA = "UPDATE_DIET";
export const DELETE_ITEM = "DELETE_DIET";
export const DRAG_ITEM = "DRAG_DIET";

export function actionFetchDiet(
  index = 1,
  sorting = {},
  filter = {},
  shouldReset = false
) {
  const request = serviceGetDiet({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    if (shouldReset) {
      dispatch({
        type: CHANGE_PAGE,
        payload: 1,
      });
    }
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionCreateDiet(data) {
  const request = serviceCreateDiet(data);
  return (dispatch) => {
    request.then((data) => {
      if (!data.error) {
        dispatch({ type: CREATE_DATA, payload: data.data });
      }
    });
  };
}

export function actionUpdateDiet(data) {
  const request = serviceUpdateDiet(data);
  return (dispatch) => {
    request.then((data) => {
      if (!data.error) {
        dispatch({ type: UPDATE_DATA, payload: data.data });
      }
    });
  };
}

export function actionDeleteDiet(id) {
  const request = serviceDeleteDiet({ id: id });
  return (dispatch) => {
    dispatch({ type: DELETE_ITEM, payload: id });
  };
}

export function actionChangePageDietRequests(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function actionFilterDiet(value) {
  const request = null; ////serviceFetchProviderRequests(value);
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null }); //dispatch function
    });
  };
}

export function actionChangeStatusDiet(id, status) {
  // const request = serviceFetchProviderRequests(value);
  return (dispatch) => {
    dispatch({ type: CHANGE_STATUS, payload: { id, status } });
  };
}

export function actionResetFilterDiet() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}

export function actionDragDiet(dragId, dragOverId) {
  return {
    type: DRAG_ITEM,
    payload: { dragId, dragOverId },
  };
}

export function actionSetPageDiet(page) {
  const stateData = store.getState().diet;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchDiet(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
